import React from "react";
import { makeStyles } from "@mui/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import Colors from "../../theme/colors.json";
import PrePolicyPlacement from "./PrePolicyPlacement";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    width: "100%",
    height: "100%",
  },
  PolicyManagementContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "2vh",
    "@media (min-width: 2000px)": {
      padding: "3.3%  2% 2% 2%",
    },
    "@media (min-width: 1500px) and (max-width: 2000px)": {
      padding: "3.3%  2% 2% 2%",
    },
    "@media (min-width: 1000px) and (max-width: 1500px)": {
      padding: "4.3%  2% 2% 2%",
    },
    "@media (min-width: 600px) and (max-width: 1000px)": {
      padding: "7%  2% 2% 2%",
    },
    "@media (max-width: 600px)": {
      padding: "10%  2% 2% 2%",
    },
  },
  PolicyManagementHeadingSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    height: "10%",
    color: Colors.WHITE,
    borderRadius: "0.5vw",
  },
  backIcon: {
    color: Colors.WHITE,
  },
  PolicyManagementHeadingText: {
    margin: "0 auto",
    fontSize: "2vw",
    fontWeight: 700,
  },
  PrePolicyPlacementContainer: {},
}));

const PolicyManagement = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(`${process.env.PUBLIC_URL}/proposalList`);
  };

  return (
    <div className={classes.mainContainer}>
      <div className={classes.PolicyManagementContainer}>
        {/* <div className={classes.PolicyManagementHeadingSection}>
          <div>
            <IconButton className={classes.backIcon} onClick={handleBack}>
              <ArrowBackIcon />
            </IconButton>
          </div>
          <div className={classes.PolicyManagementHeadingText}>
            Policy Management & Customer Care
          </div>
        </div> */}
        <div className={classes.PrePolicyPlacementContainer}>
          <PrePolicyPlacement />
        </div>
      </div>
    </div>
  );
};

export default PolicyManagement;
